// Delete Document Use Case

import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import DocumentUploadRepository from "@/core/customers/repositories/DocumentUploadRepository";
import {
  DeleteDocumentRequest,
  DeleteDocumentResponse,
} from "@/core/customers/entities/DocumentUpload";

export default class DeleteDocumentUseCase {
  constructor(
    private readonly documentUploadRepository: DocumentUploadRepository
  ) {}

  /**
   * Executes the delete document use case.
   *
   * @param request - Delete document request
   * @returns A promise resolving with DeleteDocumentResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(
    request: DeleteDocumentRequest
  ): Promise<DeleteDocumentResponse> {
    try {
      return await this.documentUploadRepository.deleteDocument(request);
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
